/**
 * Marcador client-side (sessionStorage) de "estou no meio do cadastro" —
 * usado pra decidir se as telas de MFA (e-mail/SMS) mostram o stepper/copy
 * de "etapa do cadastro" ou a copy genérica atual. Sem estado no servidor:
 * se ausente/expirado, o comportamento é idêntico ao de produção hoje.
 */

const STORAGE_KEY = 'alelo_signup_flow_started_at'
const TTL_MS = 15 * 60 * 1000

function readTimestamp(): number | null {
  try {
    const raw = window.sessionStorage.getItem(STORAGE_KEY)
    if (!raw) return null
    const parsed = Number(raw)
    return Number.isFinite(parsed) ? parsed : null
  } catch {
    return null
  }
}

/** Grava o marcador com o instante atual. Chamar só depois de validações client-side passarem, antes do submit real. */
export function start(): void {
  try {
    window.sessionStorage.setItem(STORAGE_KEY, String(Date.now()))
  } catch {
    /* sessionStorage indisponível — sem stepper de cadastro, comportamento genérico segue valendo */
  }
}

/** True se o marcador existe e tem no máximo 15 minutos. */
export function isActive(): boolean {
  const startedAt = readTimestamp()
  if (startedAt === null) return false
  return Date.now() - startedAt <= TTL_MS
}

/** Remove o marcador (chamar ao concluir a última etapa do fluxo). */
export function clear(): void {
  try {
    window.sessionStorage.removeItem(STORAGE_KEY)
  } catch {
    /* nada a limpar se sessionStorage já não está acessível */
  }
}
